export default {
  center: new window.THREE.Vector2(0, 0),
  left: new window.THREE.Vector2(1, 0),
  topLeft: new window.THREE.Vector2(1, -1),
  topRight: new window.THREE.Vector2(-1, -1),
  right: new window.THREE.Vector2(-1, 0),
  bottomLeft: new window.THREE.Vector2(1, 1),
  bottomRight: new window.THREE.Vector2(-1, 1),
}
